document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.swatch');
  if (!swatch) return;

  const variantId = swatch.dataset.variantId;
  if (!variantId) return;

  const diffuserItem = swatch.closest('.diffuser-item');
  if (!diffuserItem) return;

  const imgEl = diffuserItem.querySelector('.difuser-image img');
  if (!imgEl) return;

  // Shopify exposes variant images via data attributes only if we add them
  const variantImage = swatch.getAttribute('data-variant-image');

  if (variantImage) {
    imgEl.src = variantImage;
    imgEl.srcset = variantImage;
  }

  // active state (optional but recommended)
  diffuserItem.querySelectorAll('.swatch').forEach(s => s.classList.remove('is-active'));
  swatch.classList.add('is-active');
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.accordion-heading').forEach(heading => {
    heading.addEventListener('click', function () {
      const accordion = this.parentElement;
      const content = accordion.querySelector('.accordion-content');
      const icon = this.querySelector('.accordion-icon');
      const isOpen = accordion.classList.contains('active');

      // Close all other accordions (optional)
      document.querySelectorAll('.accordion.active').forEach(item => {
        if (item !== accordion) {
          const c = item.querySelector('.accordion-content');
          c.style.height = c.scrollHeight + 'px';
          requestAnimationFrame(() => {
            c.style.height = '0px';
          });
          item.classList.remove('active');
          item.querySelector('.accordion-icon').textContent = '+';
        }
      });

      if (!isOpen) {
        // OPEN
        accordion.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
        icon.textContent = '−';
      } else {
        // CLOSE (smooth)
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });
        accordion.classList.remove('active');
        icon.textContent = '+';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  async function enforceStarterBundleGift() {
   if (window.STARTER_BUNDLE_HIDE_GIFT) {
    return;
  }
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      let hasBundleDiffuser = false;
      let hasBundleScent = false;
      let giftLineKey = null;

      cart.items.forEach(item => {
        if (item.properties && item.properties._starter_bundle === 'true') {
          if (item.properties._free_scent === 'Starter Kit') {
            hasBundleScent = true;
          } else {
            hasBundleDiffuser = true;
          }
        }

        if (item.variant_id === FREE_GIFT_VARIANT_ID) {
          giftLineKey = item.key;
        }
      });

      // ADD gift
      if (hasBundleDiffuser && hasBundleScent && !giftLineKey) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: FREE_GIFT_VARIANT_ID,
            quantity: 1,
            properties: { _starter_bundle_gift: 'true' }
          })
        });
      }

      // REMOVE gift
      if ((!hasBundleDiffuser || !hasBundleScent) && giftLineKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftLineKey,
            quantity: 0
          })
        });
      }

    } catch (e) {
      console.error('Starter bundle gift error', e);
    }
  }
  enforceStarterBundleGift();

  // Also run when cart is refreshed
  document.addEventListener('cart:refresh', enforceStarterBundleGift);

  // Listen for Rebuy remove/qty buttons (if using Rebuy)
  document.addEventListener('click', function(e) {
    const target = e.target;
    if (target.closest('.rebuy-cart__flyout-item-remove') ||
        target.closest('.rebuy-cart__flyout-item-quantity-widget-button')) {
      setTimeout(enforceStarterBundleGift, 500);
    }
  });

  let selectedDiffuserVariant = null;
  let selectedDiffuserVariantTitle = null;
  let selectedScentVariant = null;
  let isAddingToCart = false;
  let selectedScentSellingPlan = null; 
  let diffuserConfirmed = false;
const starterBundleSection = document.querySelector('.starter-diffuser');

  const rightPart = document.querySelector('.right-part');
  const toggle = document.querySelector('.mobile-accordion-toggle');

  if (!rightPart || !toggle) return;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  toggle.addEventListener('click', function () {
  if (!isMobile()) return;

  rightPart.classList.toggle('open');

  document.body.style.overflow =
    rightPart.classList.contains('open') ? 'hidden' : '';
});

  // Safety: if user resizes to desktop, reset state
  window.addEventListener('resize', function () {
    if (!isMobile()) {
      rightPart.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  const addToCartBtn = document.querySelector('.whole-atc');

  function updateAddToCartState() {
  if (diffuserConfirmed && selectedScentVariant) {
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
  } else {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
  }
}

   updateAddToCartState();

   function updateBundleCount() {
  let count = 0;

  if (selectedDiffuserVariant) count++;
  if (selectedScentVariant) count++;

  const bundleTitle = document.querySelector('.Bundle-selec span');

  if (!bundleTitle) return;

  bundleTitle.childNodes[0].nodeValue = `${count}/2 Selected `;
}
function updateTotalKitPrice() {
  const totalWrap = document.querySelector('.total-kit-price');
  const priceEl = totalWrap?.querySelector('.price');

  if (!totalWrap || !priceEl) return;

  // Show ONLY when scent is selected
  if (!selectedScentVariant) {
    totalWrap.style.display = 'none';
    return;
  }

  const totalToday = selectedDiffuserPrice;
  const compareAt = selectedDiffuserPrice + selectedScentPrice;

  totalWrap.style.display = 'block';

  priceEl.innerHTML = `
    <span class="today">$${totalToday.toFixed(2)}</span>
    <span class="compare-at">$${compareAt.toFixed(2)}</span>
  `;
}

  const step1Container = document.querySelector('.starter-diffuser-step1');
const step2Container = document.querySelector('.starter-diffuser-step2');
const nextStepBtn = document.querySelector('.next-step-btn');
const step1title = document.querySelector('.step1-title');
let selectedDiffuserPrice = 0;
let selectedScentPrice = 0;

  const diffuserSummaryItem = document.querySelector('.summary-diffuser');
  const scentSummaryItem = document.querySelector('.summary-scent');

  function updateBundlePreview() {
  const diffuserImg = diffuserSummaryItem.querySelector('img');
  const scentImg = scentSummaryItem.querySelector('img');

  const previewDiffuser = document.querySelector('.preview-diffuser');
  const previewScent = document.querySelector('.preview-scent');

  if (!previewDiffuser || !previewScent) return;

  previewDiffuser.innerHTML = diffuserImg
    ? `<img src="${diffuserImg.src}" alt="">`
    : '';

  previewScent.innerHTML = scentImg
    ? `<img src="${scentImg.src}" alt="">`
    : '';
}

  const diffuserContent = diffuserSummaryItem.querySelector('.summary-content');
  const diffuserMeta = diffuserSummaryItem.querySelector('.summary-meta');

  const scentContent = scentSummaryItem.querySelector('.summary-content');
  const scentMeta = scentSummaryItem.querySelector('.summary-meta');

  // Enable Next button only when a diffuser is selected
document.querySelectorAll('.diffuser-add-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    if (!btn.classList.contains('is-soldout')) {
      // Enable Next button
      nextStepBtn.disabled = false;
    }
  });
});


const breadcrumbDiffuser = document.querySelector('.breadcrumb-diffuser');
const breadcrumbScent = document.querySelector('.breadcrumb-scent');

  breadcrumbScent.classList.add('is-disabled');


// When moving to Step 2
nextStepBtn.addEventListener('click', function() {
  if (!selectedDiffuserVariant) {
    alert('Please select a diffuser before continuing.');
    return;
  }
  // Hide Step 1 and Next button
  step1Container.classList.add('is-hidden');
  nextStepBtn.classList.add('is-hidden');
  step1title.classList.add('is-hidden');

  // Show Step 2
  step2Container.classList.remove('is-hidden');

  // Update breadcrumb colors
  breadcrumbDiffuser.classList.remove('active-step'); // lighter
  breadcrumbScent.classList.add('active-step');        // darker
});

breadcrumbScent.addEventListener('click', function () {
  // ❗ Block jump if diffuser not selected
  if (!selectedDiffuserVariant) {
    alert('Please select a diffuser first.');
    return;
  }

  if (this.classList.contains('is-disabled')) return;

  // Hide Step 1
  step1Container.classList.add('is-hidden');
  step1title.classList.add('is-hidden');
  nextStepBtn.classList.add('is-hidden');

  // Show Step 2
  step2Container.classList.remove('is-hidden');

  // Breadcrumb state
  breadcrumbDiffuser.classList.remove('active-step');
  breadcrumbScent.classList.add('active-step');
});

const backToStepTriggers = document.querySelectorAll(
  '.back-to-step1, .summary-diffuser .summary-remove'
);

function goBackToStep1() {
  step2Container.classList.add('is-hidden');
  step1Container.classList.remove('is-hidden');
  step1title.classList.remove('is-hidden');
  nextStepBtn.classList.remove('is-hidden');

  breadcrumbDiffuser.classList.add('active-step');
  breadcrumbScent.classList.remove('active-step');
  autoSelectFirstDiffuserSwatch();
}

backToStepTriggers.forEach(el => {
  el.addEventListener('click', goBackToStep1);
});

const prevStepBtn = document.querySelector('.prev-step-btn');

if (prevStepBtn) {
  prevStepBtn.addEventListener('click', function () {
    // Hide Step 2
    step2Container.classList.add('is-hidden');

    // Show Step 1
    step1Container.classList.remove('is-hidden');
    step1title.classList.remove('is-hidden');
    nextStepBtn.classList.remove('is-hidden');

    // Breadcrumb state
    breadcrumbDiffuser.classList.add('active-step');
    breadcrumbScent.classList.remove('active-step');

    // Optional: scroll back to top of step 1
    step1Container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

  /* ===============================
   AUTO-SELECT FIRST AVAILABLE DIFFUSER VARIANT (VISUAL ONLY)
=============================== */
function autoSelectFirstDiffuserSwatch() {
  document.querySelectorAll('.diffuser-item').forEach(diffuserItem => {
    const firstSwatch = diffuserItem.querySelector('.variant-swatches .swatch');
    if (!firstSwatch) return;

    // Highlight visually
    firstSwatch.classList.add('active');

    // Store selected variant on this diffuser
    diffuserItem.dataset.selectedVariantId = firstSwatch.dataset.variantId;
    diffuserItem.dataset.selectedVariantTitle = firstSwatch.getAttribute('aria-label');

    // ALSO update global selectedDiffuserVariant
    selectedDiffuserVariant = firstSwatch.dataset.variantId;
    selectedDiffuserVariantTitle = firstSwatch.getAttribute('aria-label');

    // Update image
    const imageEl = diffuserItem.querySelector('.difuser-image img');
    if (imageEl && firstSwatch.dataset.variantImage) {
      imageEl.src = firstSwatch.dataset.variantImage;
      imageEl.srcset = firstSwatch.dataset.variantImage;
    }
  });
}




autoSelectFirstDiffuserSwatch();
  /* ===============================
     DIFFUSER SWATCH SELECT
  =============================== */
  document.querySelectorAll('.variant-swatches .swatch').forEach(swatch => {
  swatch.addEventListener('click', function () {
    const diffuserItem = this.closest('.diffuser-item');

    // Remove active from all swatches in this diffuser
    diffuserItem.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
    this.classList.add('active');

    // Update dataset for this diffuser only
    diffuserItem.dataset.selectedVariantId = this.dataset.variantId;
    diffuserItem.dataset.selectedVariantTitle = this.getAttribute('aria-label');

    // Update image
    const imgEl = diffuserItem.querySelector('.difuser-image img');
    if (imgEl && this.dataset.variantImage) {
      imgEl.src = this.dataset.variantImage;
      imgEl.srcset = this.dataset.variantImage;
    }
  });
});


  /* ===============================
     DIFFUSER CONFIRM
  =============================== */
document.querySelectorAll('.diffuser-item .diffuser-add-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const diffuserItem = this.closest('.diffuser-item');

    // Use the per-diffuser selected variant
    const selectedVariantId = diffuserItem.dataset.selectedVariantId;
    const selectedVariantTitle = diffuserItem.dataset.selectedVariantTitle;

    if (!selectedVariantId) {
      alert('Please select a diffuser variant');
      return;
    }

    diffuserConfirmed = true;
    breadcrumbScent.classList.remove('is-disabled');

    // Reset all other buttons
    document.querySelectorAll('.diffuser-add-btn').forEach(b => {
      if (!b.classList.contains('is-soldout')) {
        b.classList.remove('is-selected');
        b.textContent = 'Add';
      }
    });

    // Mark this button as selected
    this.classList.add('is-selected');
    this.textContent = 'Selected';

    // Price and image
    const price = diffuserItem.querySelector('p').innerText;
    const variantImage = diffuserItem.querySelector(`.variant-swatches .swatch[data-variant-id="${selectedVariantId}"]`)?.dataset.variantImage || diffuserItem.dataset.image;

    diffuserContent.innerHTML = `<img src="${variantImage}" alt="${diffuserItem.dataset.title}">`;
    diffuserMeta.innerHTML = `
      <h4>${diffuserItem.dataset.title}</h4>
      <p>${price}</p>
      <p>Color: ${selectedVariantTitle}</p>
    `;

    diffuserSummaryItem.classList.add('is-selected');
    selectedDiffuserPrice = parseFloat(price.replace(/[^0-9.]/g, ''));

    // GA Event
    gtag('event', 'select_item', {
      items: [{
        item_name: diffuserItem.dataset.title,
        item_category: 'Diffuser',
        price: selectedDiffuserPrice,
        quantity: 1
      }]
    });

    // Update globals so bundle code sees the selected diffuser
    selectedDiffuserVariant = selectedVariantId;
    selectedDiffuserVariantTitle = selectedVariantTitle;

    updateBundleCount();
    updateAddToCartState();
    updateBundlePreview();
    updateTotalKitPrice();
  });
});


  /* ===============================
     REMOVE DIFFUSER
  =============================== */
 diffuserSummaryItem.querySelector('.summary-remove')
  .addEventListener('click', function () {

    breadcrumbScent.classList.add('is-disabled');

    // Reset selected variables
    selectedDiffuserVariant = null;
    selectedDiffuserVariantTitle = null;
    diffuserConfirmed = false;
    nextStepBtn.disabled = true;
    isAddingToCart = false;

    // Reset summary display
    diffuserContent.innerHTML = `<p class="placeholder">Select your Diffuser</p>`;
    diffuserMeta.innerHTML = '';
    diffuserSummaryItem.classList.remove('is-selected');

    // Remove active swatches
    document.querySelectorAll('.variant-swatches .swatch')
      .forEach(btn => btn.classList.remove('active'));

    // Reset Add buttons, but skip sold-out buttons
    document.querySelectorAll('.diffuser-add-btn')
      .forEach(btn => {
        if (!btn.classList.contains('is-soldout')) {
          btn.classList.remove('is-selected');
          btn.textContent = 'Add';
          btn.disabled = false; // Only enable buttons that are not sold-out
        }
      });

selectedDiffuserPrice = 0;

const totalWrap = document.querySelector('.total-kit-price');
if (totalWrap) totalWrap.style.display = 'none';
    autoSelectFirstDiffuserSwatch();
    updateBundleCount();
    updateAddToCartState();
    updateBundlePreview(); 
    enforceStarterBundleGift();
  });
  /* ===============================
   SCENT SELECT
=============================== */
document.querySelectorAll('.scent-item .button').forEach(btn => {
  btn.addEventListener('click', function () {

    const scentItem = this.closest('.scent-item');
    selectedScentVariant = scentItem.querySelector('.scent-variant-id').value;
    selectedScentSellingPlan = this.dataset.sellingPlanId || null;
    const scentPrice = this.dataset.price;
    const scentNotes = this.dataset.scentNotes || '';
    const priceNumber = parseFloat(scentPrice.replace(/[^0-9.]/g, ''));
    const discountedPrice = (priceNumber * 0.8).toFixed(2);
    const refillPricing = document.querySelector('.Refill-pricing');
    refillPricing.innerHTML = `-
  <span class="price">$${discountedPrice}</span>
  <span class="compare-at">$${priceNumber.toFixed(2)}</span>
`;

    // Remove active class from all scent items
    document.querySelectorAll('.scent-item').forEach(item => item.classList.remove('active'));
    scentItem.classList.add('active');

    // Update summary content
    scentContent.innerHTML = `<img src="${this.dataset.image}" alt="">`;
    scentMeta.innerHTML = `
      <h4>${this.dataset.title}</h4>
      <div class="new-flex-div"><p>Free</p>
      <p class="compare">${scentPrice}</p></div>
      <p class="scet-not">${scentNotes}</p>
    `;
    scentSummaryItem.classList.add('is-selected');

    // Reset all scent buttons except sold out
    document.querySelectorAll('.scent-item .button').forEach(b => {
      if (!b.classList.contains('is-soldout')) {
        b.classList.remove('is-selected');
        b.textContent = 'Add';
      }
    });

    // Set the clicked button as selected if not sold out
    if (!this.classList.contains('is-soldout')) {
      this.classList.add('is-selected');
      this.textContent = 'Selected';
    }
    selectedScentPrice = priceNumber;

    gtag('event', 'select_item', {
      items: [{
        item_name: this.dataset.title,
        item_category: 'Scent',
        price: 0,
        quantity: 1
      }]
    });

    updateBundleCount();
    updateAddToCartState();
    updateBundlePreview();
    updateTotalKitPrice();
  });
});

/* ===============================
   REMOVE SCENT
=============================== */
scentSummaryItem.querySelector('.summary-remove')
  .addEventListener('click', function () {

    selectedScentVariant = null;
    selectedScentSellingPlan = null;
    isAddingToCart = false;

     const refillPricing = document.querySelector('.Refill-pricing');
    if (refillPricing) {
      refillPricing.innerHTML = '';
    }

    scentContent.innerHTML = `<p class="placeholder">Select your Scent</p>`;
    scentMeta.innerHTML = '';
    scentSummaryItem.classList.remove('is-selected');

    // Remove active class from all scent items
    document.querySelectorAll('.scent-item').forEach(item => item.classList.remove('active'));

    // Reset all scent buttons except sold out
    document.querySelectorAll('.scent-item .button').forEach(b => {
      if (!b.classList.contains('is-soldout')) {
        b.classList.remove('is-selected');
        b.textContent = 'Add';
      }
    });
    selectedScentPrice = 0;

const totalWrap = document.querySelector('.total-kit-price');
if (totalWrap) totalWrap.style.display = 'none';

    updateBundleCount();
    updateAddToCartState();
    updateBundlePreview();
    enforceStarterBundleGift();
  });

  /* ===============================
     WHOLE ADD TO CART (SAFE)
  =============================== */
  document.querySelector('.whole-atc')
    .addEventListener('click', function () {

      if (isAddingToCart) return;

      isAddingToCart = true;
      this.classList.add('loading');
     

      fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  credentials: 'same-origin',
  body: JSON.stringify({
   items: [
  {
    id: Number(selectedDiffuserVariant),
    quantity: 1,
    properties: {
      _starter_bundle: 'true',
      _is_diffuser: 'true'
    }
  },
  {
    id: Number(selectedScentVariant),
    quantity: 1,
    selling_plan: selectedScentSellingPlan
      ? Number(selectedScentSellingPlan)
      : undefined,
    properties: {
      _starter_bundle: 'true',
      _free_scent: 'Starter Kit'
    }
  }
]
  })
})
.then(async res => {
  const data = await res.json();
  console.log('STATUS:', res.status);
  console.log('RESPONSE:', data);

  if (!res.ok) throw data;
})
.then(async () => {
  await enforceStarterBundleGift();
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  console.log("Add to Cart successful. Firing dynamic GA4 event.");
    gtag("event", "add_to_cart", {
      currency: "USD",
      value: selectedDiffuserPrice + selectedScentPrice, // The total value of all items
      items: [
        {
          item_id: selectedDiffuserVariant,
          item_name: 'Starter Kit',
          price: selectedDiffuserPrice,
          quantity: 1
        },
        {
          item_id: selectedScentVariant,
          item_name: 'Starter Kit',
          price: selectedScentPrice,
          quantity: 1
        }
      ]
    });
})
.catch(err => {
  console.error('CART ERROR:', err);
  alert(err.description || 'Add to cart failed');
})
.finally(() => {
  isAddingToCart = false;
  addToCartBtn.classList.remove('loading');
});
    });

    document.addEventListener('cart:refresh', enforceStarterBundleGift);

document.addEventListener('click', function(e) {
  const target = e.target;

  // Remove item button
  if (target.closest('.rebuy-cart__flyout-item-remove') ||
      target.closest('.rebuy-cart__flyout-item-quantity-widget-button')) {
    // Wait a tick for cart update to finish
    setTimeout(() => {
      enforceStarterBundleGift();
    }, 500); // 500ms delay, adjust if needed
  }
});

});
